import { Dashboard } from "@mui/icons-material";

export const sidebarMenuData = [
    { id: 1, label: 'Dashboard', icon: <Dashboard />, path: '/dashboard' },
    { 
        id: 2, 
        label: 'Optimization', 
        icon: '', 
        path: '',
        submenu: [
            { id: 21, label: 'Big Query', icon: <Dashboard />, path: '/optimization/big-query' },
            { id: 22, label: 'Compute Engine', icon: <Dashboard />, path: '/optimization/compute-engine' },
            { id: 23, label: 'Cloud SQL', icon: <Dashboard />, path: '/optimization/cloud-sql' },
            { id: 24, label: 'Cloud Run', icon: <Dashboard />, path: '/optimization/cloud-run' }
        ]
    },
    { 
        id: 3, 
        label: 'Cost Control', 
        icon: '', 
        path: '',
        submenu: [
            { id: 31, label: 'Cost Anomaly Detection', icon: <Dashboard />, path: '/dashboard' },
        ]
    },
    { 
        id: 4, 
        label: 'Insights', 
        icon: '', 
        path: '',
        submenu: [
            { id: 41, label: 'Labels', icon: <Dashboard />, path: '/dashboard' },
        ]
    },
    { 
        id: 5, 
        label: 'Settings', 
        icon: '', 
        path: '',
        submenu: [
            { id: 51, label: 'Notifications', icon: <Dashboard />, path: '/dashboard' },
            { id: 52, label: 'Access Management', icon: <Dashboard />, path: '/dashboard' },
        ] 
    },
    // Add more menu items as needed
  ];
  